'use strict';/* global define:false */define('modules/360-feedback/directives/360-feedback/controller',['angular'],function(ng){'use strict';// @ngInject
controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.editing=false;ctrl.edit=edit;ctrl.feedback=$scope.feedback;// working around API inconsistency regarding
// the `property` which returns a Number or an Array
ctrl.pendingLength=ctrl.feedback.pending instanceof Array?ctrl.feedback.pending.length:ctrl.feedback.pending;// ---
function edit(){ctrl.editing=!ctrl.editing;}}return controller;});
